import { MenuItem } from '@ui-lib/components';
import { NavigationMenuEnum } from './model/navigation-menu.enum';
import { UserPermissionEnum } from '../../../core/models/user-permissions.enum';

export interface PermissionMenuItem<T = string> extends MenuItem<T> {
  requiredPermissionsAny?: UserPermissionEnum[];
}

export const MENU_ITEMS: PermissionMenuItem<NavigationMenuEnum>[] = [
  {
    id: NavigationMenuEnum.Main,
    titleTranslateKey: 'monitoring.menu.dashboard',
    url: '/',
    icon: 'main',
  },
  {
    id: NavigationMenuEnum.Facilities,
    titleTranslateKey: 'monitoring.menu.facilities',
    url: '/facilities',
    icon: 'widget-add',
    requiredPermission: UserPermissionEnum.FacilityRead,
    isExact: false,
  },
  {
    id: NavigationMenuEnum.Placement,
    titleTranslateKey: 'monitoring.menu.placement',
    url: '/placement',
    icon: 'slider-vertical',
    requiredPermission: UserPermissionEnum.ContainerRead,
    isExact: false,
  },
  {
    id: NavigationMenuEnum.Devices,
    titleTranslateKey: 'monitoring.menu.devices',
    url: '/devices',
    icon: 'check-square',
    requiredPermission: UserPermissionEnum.EquipmentRead,
    isExact: false,
  },
  {
    id: NavigationMenuEnum.Scanner,
    titleTranslateKey: 'monitoring.menu.scanner',
    url: '/scanner',
    icon: 'scanner',
    requiredPermission: UserPermissionEnum.ScansRead,
    isExact: false,
  },
  {
    id: NavigationMenuEnum.Notifications,
    titleTranslateKey: 'monitoring.menu.notifications',
    url: '/notifications',
    icon: 'bell',
    requiredPermission: UserPermissionEnum.EquipmentEventRead,
    isExact: false,
  },
  {
    id: NavigationMenuEnum.Maintenance,
    titleTranslateKey: 'monitoring.menu.maintenance',
    url: '/maintenance',
    icon: 'hammer',
    requiredPermission: UserPermissionEnum.MaintenanceRead,
    isExact: false,
  },
  {
    id: NavigationMenuEnum.Firmwares,
    titleTranslateKey: 'monitoring.menu.firmwares',
    url: '/firmwares',
    icon: 'code',
    requiredPermission: UserPermissionEnum.FirmwareRead,
    isExact: false,
  },
  {
    id: NavigationMenuEnum.Users,
    titleTranslateKey: 'monitoring.menu.users',
    url: '/users',
    icon: 'user-line',
    requiredPermission: UserPermissionEnum.UserRead,
    isExact: false,
  },
  {
    id: NavigationMenuEnum.Roles,
    titleTranslateKey: 'monitoring.menu.roles',
    url: '/roles',
    icon: 'users',
    requiredPermission: UserPermissionEnum.RoleRead,
    isExact: false,
  },
  {
    id: NavigationMenuEnum.ServiceCenters,
    titleTranslateKey: 'monitoring.menu.service-centers',
    url: '/service-centers',
    icon: 'storage',
    requiredPermission: UserPermissionEnum.MaintenanceRead,
    isExact: false,
  },
  {
    id: NavigationMenuEnum.History,
    titleTranslateKey: 'monitoring.menu.history',
    url: '/history',
    icon: 'notebook',
    requiredPermission: UserPermissionEnum.AuditRead,
    isExact: false,
  },
  {
    id: NavigationMenuEnum.Workers,
    titleTranslateKey: 'monitoring.menu.workers',
    url: '/workers',
    icon: 'share-circle',
    requiredPermission: UserPermissionEnum.WorkerRead,
    isExact: false,
  },
  {
    id: NavigationMenuEnum.Agents,
    titleTranslateKey: 'monitoring.menu.agents',
    url: '/agents',
    icon: 'agent',
    requiredPermission: UserPermissionEnum.AgentRead,
    isExact: false,
  },
  {
    id: NavigationMenuEnum.KnowledgeBase,
    titleTranslateKey: 'monitoring.menu.knowledge-base',
    url: '/knowledge-base',
    icon: 'glasses',
    requiredPermissionsAny: [
      UserPermissionEnum.ManufacturerRead,
      UserPermissionEnum.EquipmentModelRead,
      UserPermissionEnum.PoolRead,
    ],
    isExact: false,
  },
];
